(function () {
    'use strict';

    angular.module("imApp").factory("sopsService", ['$ihttp', function ($ihttp) {
        let service = {
            listSops: function (parms) {
                return $ihttp.post({
                    method: 1838,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
